module.exports = __webpack_public_path__ + "img/booths_mobile.b2ae0df5.svg";